import type { ForjaApk } from '@mxa-argos/modules/forja/interfaces/forja-apk.interface';
import type { ForjaDeviceSession } from '@mxa-argos/modules/forja/lib/engine/forja-device-session';
import { toForjaErrorCode, toForjaErrorDetail } from '@mxa-argos/modules/forja/lib/forja-error';
import { DeviceProvisioner } from '@mxa-argos/modules/forja/lib/provisioning/device-provisioner';
import type { Semaphore } from '@mxa-argos/modules/forja/lib/semaphore';

export async function provisionBatch(
  devices: ForjaDeviceSession[],
  apks: ForjaApk[],
  installSlots: Semaphore,
): Promise<void> {
  await Promise.all(
    devices.map(async (device) => {
      try {
        await new DeviceProvisioner(device, apks, installSlots).run();
      } catch (error) {
        device.emit({
          type: 'finished',
          wasSuccessful: false,
          errorCode: toForjaErrorCode(error),
          errorDetail: toForjaErrorDetail(error),
        });
      }
    }),
  );
}
